var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityVerified({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-AE080-security_verified",
    "data-name": "Icon-AE080-security verified",
    transform: "translate(7010 6623)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Size",
    width: 48,
    height: 48,
    transform: "translate(-7010 -6623)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AE080-security_verified",
    "data-name": "AE080-security verified",
    d: "M12.627,4.871a10.961,10.961,0,0,1,8.5-2.816,11.334,11.334,0,0,1,9.942,10.95l.009.461V22.05h.985a4.035,4.035,0,0,1,4.018,3.729l.011.3v8.06A7.979,7.979,0,0,1,28.522,42.1l-.4.01H11.969A7.979,7.979,0,0,1,4.01,34.537L4,34.14v-8.06a4.035,4.035,0,0,1,3.729-4.018l.3-.011h.985V13.036A11.057,11.057,0,0,1,12.627,4.871Zm-4.6,19.185a2.026,2.026,0,0,0-2.012,1.8l-.012.22v8.06a5.971,5.971,0,0,0,5.613,5.953l.35.01H28.125a5.971,5.971,0,0,0,5.953-5.613l.01-.35v-8.06a2.026,2.026,0,0,0-1.8-2.012l-.22-.012Zm17.547,2.155a1,1,0,0,0-1.375.344l-5.357,8.928-3.1-3.1-.139-.116A1,1,0,0,0,14.323,33.8l4.012,4.012.121.1a1,1,0,0,0,.588.191l.123-.008a1,1,0,0,0,.737-.479l6.018-10.029L26,27.424A1,1,0,0,0,25.576,26.211ZM20.936,4.051a9.028,9.028,0,0,0-9.9,8.51l-.013.474V22.05h2.006V13.024a7.02,7.02,0,0,1,14.03-.385l.01.385V22.05h2.006V13.466A9.332,9.332,0,0,0,20.936,4.051Zm-5.893,8.643a5.015,5.015,0,0,1,10.019.329V22.05H15.032V13.024Z",
    transform: "translate(-7005.977 -6620.991)",
    fill: "#ec0000",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityVerified);
export default __webpack_public_path__ + "static/media/security-verified.218165e96494824e000f3873a2bcc6a8.svg";
export { ForwardRef as ReactComponent };